/**
 * Carousel scroll animation - shrinks and fades carousel when reaching latest episodes section
 */
(function() {
  'use strict';

  function initCarouselScrollAnimation() {
    const carouselColumn = document.querySelector('.podcast-section--what-this-is__carousel-column');
    const columnsContainer = document.querySelector('.podcast-section--what-this-is__columns');
    const latestEpisodesSection = document.getElementById('latest-episodes');
    
    if (!carouselColumn || !columnsContainer || !latestEpisodesSection) return;

    // Check if we're on mobile (max-width: 749px) - skip animation on mobile
    const mql = window.matchMedia('(max-width: 749px)');
    if (mql.matches) {
      return; // Exit early on mobile - no animation needed
    }

    // Use IntersectionObserver to detect when latest episodes section enters viewport
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1 // Trigger when 10% of the section is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Latest episodes section is in view - add class to shrink and fade carousel
          carouselColumn.classList.add('scrolled-to-episodes');
          columnsContainer.classList.add('scrolled-to-episodes');
        } else {
          // Latest episodes section is out of view - remove class to restore carousel
          carouselColumn.classList.remove('scrolled-to-episodes');
          columnsContainer.classList.remove('scrolled-to-episodes');
        }
      });
    }, observerOptions);

    observer.observe(latestEpisodesSection);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarouselScrollAnimation);
  } else {
    initCarouselScrollAnimation();
  }

  // Also run when Shopify theme editor updates
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initCarouselScrollAnimation);
  }
})();
